const features = [
  {
    icon: 'ri-flashlight-line',
    title: '全网最快',
    desc: '7×24小时全天候监控，重大爆料闪电推送，让你永远走在吃瓜第一线，绝不错过任何热点事件。',
  },
  {
    icon: 'ri-global-line',
    title: '内容最全',
    desc: '覆盖明星八卦、网红事件、综艺争议、影视剧透等全品类娱乐资讯，一站满足所有吃瓜需求。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '真实可靠',
    desc: '专业编辑团队审核把关，多方信息交叉验证，标注来源出处，为吃瓜群众提供最可信的资讯。',
  },
  {
    icon: 'ri-rocket-2-line',
    title: '体验最佳',
    desc: '智能推荐算法精准匹配兴趣偏好，APP实时推送+离线阅读，流畅的吃瓜体验让你爱不释手。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block text-xs font-label tracking-wider text-primary-600 bg-primary-100 px-4 py-1.5 rounded-full mb-4 whitespace-nowrap">
            核心优势
          </span>
          <h2 className="font-heading text-[32px] md:text-[40px] text-foreground-950">平台优势</h2>
          <p className="text-sm text-foreground-500 mt-3">全网最快最全的吃瓜平台，为你打造极致的吃瓜体验</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {features.map((feat, i) => (
            <div key={i} className="group bg-background-50 rounded-2xl p-6 md:p-7 border border-background-200/70 hover:bg-accent-50/30 hover:border-accent-200 transition-all duration-300 cursor-default">
              <div className="w-12 h-12 md:w-14 md:h-14 rounded-2xl bg-accent-100 flex items-center justify-center mb-5 group-hover:bg-accent-200 transition-colors">
                <i className={`${feat.icon} text-2xl text-accent-700`}></i>
              </div>
              <h3 className="font-heading text-lg text-foreground-900 mb-3">{feat.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}